<template>
  <div class="LKMunMehView">
    <LkBackLink
      :to="backRoute"
      class="LKMunMehView__back"
    />

    <LKProgressCircular
      v-if="isLoadingAsyncData"
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />

    <div
      v-else-if="single"
      class="LKMunMehView__content"
    >
      <LKMunMehCard
        :data="single"
        active
        actionless
        :get-mun-meh="() => ({})"
      />
    </div>
  </div>
</template>

<script>
import { LkMunMehModel as Model } from './Model'
import { lkMunMehStoreModule as StoreModule } from './store'

import LkBackLink from '@/components/lk/LkBackLink.vue'
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LKMunMehCard from '@/views/LKMunMeh/components/LKMunMehCard/LKMunMehCard.vue'
import { createViewMixin } from '@/helpers/mixins/createViewMixin'
import { LK_MUN_MEH_ROUTES } from '@/views/LKMunMeh/utils'

const mixinOptions = { Model, StoreModule }
const viewMixin = createViewMixin(mixinOptions)

export default {
  name: 'LKMunMehView',
  components: { LkBackLink, LKMunMehCard, LKProgressCircular },
  mixins: [viewMixin],
  data: () => ({
    backRoute: {
      name: LK_MUN_MEH_ROUTES.LIST,
    },
  }),
  activated() {
    // когда created, то isLoadingAsyncData === true
    if (this.isLoadingAsyncData) return
    this.asyncData(true)
  },
}
</script>

<style lang="scss">
.LKMunMehView {
  &__back {
    margin-bottom: 10px;
  }

  &__content {
    font-size: 16px;
  }
}
</style>
